export default __webpack_public_path__ + "static/media/Left Arrow.de6203f7.svg";